import React, { useContext, useMemo } from 'react';
import {
  Box,
  Drawer,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Typography,
  IconButton,
  Divider
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DisplayIcon from "../Icon/DisplayIcon";
import { GlobalContext } from '../../GlobalProvider';

const EntityTypeFilter = ({ 
  open, 
  onClose, 
  selectedTypes, 
  onToggleType, 
  selectedSensors,
  onToggleSensor
}) => {
  const { fullApp } = useContext(GlobalContext);
  
  // Get unique sensors from all entities
  const uniqueSensors = useMemo(() => {
    const sensorMap = new Map();
    
    fullApp?.entities?.forEach(entity => {
      entity.sensors?.forEach(sensor => {
        if (!sensorMap.has(sensor._id)) {
          sensorMap.set(sensor._id, sensor);
        }
      });
    });

    return Array.from(sensorMap.values());
  }, [fullApp]);

  // Default color if iconColor is undefined or null
  const DEFAULT_COLOR = "#4169E1"; // Royal Blue as default

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
    >
      <Box sx={{ width: 300, p: 2 }}>
        <Box sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 2
        }}>
          <Box sx={{ fontWeight: 'bold' }}>Filters</Box>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Entity Types Section */}
        <Typography variant="subtitle1" sx={{ mb: 1 }}>Entity Types</Typography>
        <FormGroup sx={{ mb: 2 }}>
          {fullApp?.entities?.map((entityType) => (
            <FormControlLabel
              key={entityType._id}
              control={
                <Checkbox
                  checked={selectedTypes.has(entityType._id)}
                  onChange={(e) => onToggleType(entityType._id, e.target.checked)}
                  sx={{
                    color: entityType.iconColor || DEFAULT_COLOR,
                    '&.Mui-checked': {
                      color: entityType.iconColor || DEFAULT_COLOR,
                    },
                  }}
                />
              }
              label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <DisplayIcon name={entityType.icon} height={32} width={32} />
                  <Typography variant="body1">{entityType.name}</Typography>
                </Box>
              }
            />
          ))}
        </FormGroup>

        <Divider sx={{ my: 2 }} />

        {/* Sensors Section */}
        <Typography variant="subtitle1" sx={{ mb: 1 }}>Sensors</Typography>
        <FormGroup>
          {uniqueSensors.map((sensor) => (
            <FormControlLabel
              key={sensor._id}
              control={
                <Checkbox
                  checked={selectedSensors.has(sensor._id)}
                  onChange={() => onToggleSensor(sensor._id)}
                />
              }
              label={
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                  <Typography variant="body1">{sensor.sensor_name}</Typography>
                
                </Box>
              }
            />
          ))}
        </FormGroup>
      </Box>
    </Drawer>
  );
};

export default EntityTypeFilter; 